import axios from 'axios'
import {
  headers,
  outputError,
  API_TOKEN,
  updateAPIToken
} from './token';
const BASE_URL = process.env.BASE_URL

export default {
  login(context, payload, cb) {
    console.log(payload)
    axios
      .post(`${BASE_URL}users/loginwithemail`, payload, {})
      .then(response => {
        console.log(response)
        cb(response)
      })
      .catch(error => {
        console.log(JSON.stringify(error));
        cb(error);
      });
  },

  /***
   **** catagory endpoints
   ***/

  getCatagories(context, cb) {
    const _this = context
    axios
      .get(`${BASE_URL}catagory`, headers())
      .then(response => {
        response.data.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
        _this.$store.dispatch('updateCatagories', response.data)
        cb(response)
      })
      .catch(error => {
        console.log(JSON.stringify(error));
        cb(error);
      });
  },
  saveCatagory(context, data, cb) {
    const _this = context
    axios
      .post(`${BASE_URL}catagory`, data, headers())
      .then(response => {
        console.log(response.data)
        cb(response)
      })
      .catch(error => {
        console.log(JSON.stringify(error));
        cb(error);
      });
  },
  editCatagory(context, id, data, cb) {
    axios
      .put(`${BASE_URL}catagory/${id}`, data, headers())
      .then(response => {
        console.log(response.data)
        cb(response)
      })
      .catch(error => {
        console.log(JSON.stringify(error));
        cb(error);
      });
  },

  /***
   * Jewelry Endpoints
   */
  getJewelry(context, filter, sort, catagory, cb) {
    if (catagory.id) catagory = catagory.id
    const _this = context
    axios
      .get(`${BASE_URL}jewelry?filter=${filter}&sort=${sort}&catagory=${catagory}`, headers())
      .then(response => {
        console.log(response.data)
        _this.$store.dispatch('updateJewelry', response.data)
        cb(response)
      })
      .catch(error => {
        console.log(JSON.stringify(error));
        cb(error);
      });
  },
  getAwarded(context, cb) {
    const _this = context
    axios
      .get(`${BASE_URL}jewelry/awarded`)
      .then(response => {
        console.log(response.data)
        _this.$store.dispatch('updateJewelry', response.data)
        cb(response)
      })
      .catch(error => {
        console.log(JSON.stringify(error));
        cb(error);
      });
  },
  saveJewelry(context, data, cb) {
    const _this = context
    axios
      .post(`${BASE_URL}jewelry`, data, headers())
      .then(response => {
        console.log(response.data)
        cb(response)
      })
      .catch(error => {
        console.log(JSON.stringify(error));
        cb(error);
      });
  },
  editJewelry(context, id, data, cb) {
    axios
      .put(`${BASE_URL}jewelry/${id}`, data, headers())
      .then(response => {
        console.log(response.data)
        cb(response)
      })
      .catch(error => {
        console.log(JSON.stringify(error));
        cb(error);
      });
  },
  /*** S3 Upload */
  getSignedUrl(context, file, cb) {
    const _this = context
    let name = encodeURIComponent(file.name)
    axios
      .get(`${BASE_URL}requestsignedurl?filename=${name}&filetype=${file.type}`, headers())
      .then(response => {
        cb(response)
      })
      .catch(error => {
        console.log(JSON.stringify(error));
        cb(error);
      });
  },
  uploadToS3(context, file, signedUrl, cb) {
    var options = {
      headers: {
        'Content-Type': file.type
      }
    };
    axios
      .put(signedUrl, file, options)
      .then(response => {
        console.log(response)
        cb(response)
      })
      .catch(error => {
        console.log(JSON.stringify(error));
        cb(error);
      });
  }
}


// WEBPACK FOOTER //
// ./src/api/cms.js